import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="供应商">{data.c_provider}</Description>
          <Description term="主域名">{data.c_main_domain}</Description>
          <Description term="年数">{data.c_years}</Description>
        </Row>
        <Row>
          <Description term="赠送年限">{data.c_free}</Description>
          <Description term="价格">{data.c_money}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProDomain.js